import { render, staticRenderFns } from "./locus.vue?vue&type=template&id=0d728318&scoped=true&"
import script from "./locus.vue?vue&type=script&lang=js&"
export * from "./locus.vue?vue&type=script&lang=js&"
import style0 from "./locus.vue?vue&type=style&index=0&id=0d728318&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d728318",
  null
  
)

export default component.exports